<ng-container *transloco="let t; read: 'org-settings-ivrs'">
  <p-messages severity="error">
    <ng-template pTemplate>
      <div class="ml-2">
        <strong>{{ t('title') }}</strong>
        <br />
        {{ t('description') }}
      </div>
    </ng-template>
  </p-messages>
  <app-ivr-table-editor></app-ivr-table-editor>
</ng-container>
